var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-list',{attrs:{"title":"Transaksi Terhapus","data-url":"/api/v1/sale/deleted","data-size":"10","dataHeaders":_vm.tHeaders}})}
var staticRenderFns = []

export { render, staticRenderFns }